import React from 'react'
import styled from 'styled-components';

const OptionsContainer = styled.div<{ className: string }>`
    width: 100%;
    background: ${p => p.theme.palette.primary.main};
    border-radius: 0 0 100px 100px;
    min-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;

    ${p => p.className}
`

interface IOwnProps{
    children?: any;
    className?: string;
}

const HeaderOptions: React.FunctionComponent<IOwnProps> = ({ children = <></>, className = '' }) => {
  return (
    <OptionsContainer className={className}>
        {children}
    </OptionsContainer>
  )
}

export default HeaderOptions